import { useDebouncedCallback } from "use-debounce";
import React, { useState, useRef, useEffect } from "react";
import { useUserProfile } from "../../service/hooks";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Navbar,
  Image,
  Alert,
  Card,
  Badge,
  Spinner,
  Nav,
  Dropdown,
} from "react-bootstrap";
import { useHistory, useParams, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMoon,
  faSun,
  faBars,
  faSignOutAlt,
  faPaperPlane,
  faMicrophone,
  faPaperclip,
  faLocationPin,
  faClock,
  faMagicWandSparkles,
  faSpinner,
  faHistory,
  faEnvelope,
  faWandMagicSparkles,
  faInfoCircle,
  faDownload,
  faPerson,
  faUserCircle,
  faUserEdit,
  faShieldAlt,
  faCompassDrafting,
  faMusic,
  faIdBadge,
} from "@fortawesome/free-solid-svg-icons";
import "./Chat.css"; // Custom styles
import Offcanvas from "react-bootstrap/Offcanvas";
import Logo from "../../beatai-logo.svg";
import event1 from "../../event1.jpg";
import event2 from "../../event2.jpg";
import event3 from "../../event3.jpg";
import event4 from "../../event4.jpg";
import ResponseStream from "./Streamed";
// import Markdown from "react-markdown";
import Markdown from "markdown-to-jsx";

import {
  addMessageToChat,
  API_BASE_URL,
  autoSuggest,
  changeAvatar,
  createChat,
  deleteImage,
  generateImage,
  getChatMessages,
  getChats,
  getGeneratedImages,
  resendVerification,
} from "../../service/api";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import WeatherMsg from "./WeatherMsg";
import StockQuoteCard from "./StockQuoteMsg";
import TimeLocationCard from "./DateAndTimeCard";
import NewsCard from "./NewsCard";
import moment from "moment";
import WeatherIcon from "./WeatherCodeIcon";
import Avatar, { useAvatar } from "../auth/Avatar";

function EventVenue({ title, alink, venue, time, imglink }) {
  return (
    <Card className="text-white evt-card border-0">
      <Card.Img variant="top" src={imglink} alt="Event image" />
      <Card.Body>
        <div style={{ minHeight: "60px", maxHeight: "60px" }}>
          <h6>{title}</h6> <br />
        </div>
        <a
          style={{ marginTop: "10px" }}
          href={alink}
          target="_blank"
          rel="noopener noreferrer"
          className="text-white"
          style={{ textDecoration: "underline" }}
        >
          <FontAwesomeIcon size="xs" icon={faLocationPin} /> {venue}
        </a>
        <p>
          <FontAwesomeIcon size="xs" icon={faClock} /> {time}
        </p>
      </Card.Body>
    </Card>
  );
}

function AIImage() {
  useEffect(() => {
    document.title = "BeatAI - Lex Chat";
  }, []);

  const [processing, setProcessing] = useState(false);
  const [deleteing, setDeleting] = useState(false);
  const [show, setShow] = useState(false);
  const [messages, setMessages] = useState([]);
  const [inputPosition, setInputPosition] = useState("bottom"); // 'centered' or 'bottom'
  const history = useHistory();
  const [userLocation, setUserLocation] = useState("");
  const [message, setMessage] = useState("");
  const scrollContainerRef = useRef(null);
  const verified = localStorage.getItem("verified");
  const [resendingMail, setResendingMail] = useState(false);
  const { firstname, lastname } = useUserProfile();
  const [weatherConditionCode, setWeatherConditionCode] = useState(false);
  const [isDay, setIsDay] = useState(true);

  useEffect(() => {
    fetch(API_BASE_URL + "/get_location/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    })
      .then(async (r) => {
        const d = await r.json();
        let city = d["city"]["name"];
        let country = d["country"]["name"];
        let subdiv = null;
        try {
          subdiv = d["subdivision"]["name"];
          setWeatherConditionCode(d.weather_code);
          setIsDay(d.is_day);
        } catch (e) {}

        setUserLocation(
          `${city ? city : ""}${
            city && city.length > 0 && country && country.length > 0 ? ", " : ""
          }${subdiv && country == "United States" ? subdiv : country}`
        );
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  useEffect(() => {
    getGeneratedImages()
      .then((genImages) => {
        setMessages(genImages.images);
      })
      .catch((e) => {
        // alert("There was an issue listing generated images!");
      });
  }, []);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    history.push("/login?sc=ef5199c2-e6b8-4257-9932-20aa6f449c90R");
  };

  const initChat = async () => {
    if (processing) {
      return;
    }

    const m = `${message}`;
    setMessage("");
    setProcessing(true);
    generateImage(m)
      .then((res) => {
        console.log(res);
        setProcessing(false);
        setMessages([res, ...messages]);
      })
      .catch((e) => {
        setProcessing(false);

        alert("Failure generating image!");
        console.log(e);
      });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (message.trim()) {
        setShowSuggestions(false);
        initChat();
      }
    }
  };

  const getGreet = () => {
    const now = new Date();
    const hours = now.getHours();
    let greeting;

    if (hours >= 5 && hours < 12) {
      greeting = (
        <>
          <WeatherIcon
            localDayTime={true}
            isDay={isDay}
            code={weatherConditionCode}
          />{" "}
          Good Morning
        </>
      );
    } else if (hours >= 12 && hours < 18) {
      greeting = (
        <>
          <WeatherIcon
            localDayTime={true}
            isDay={isDay}
            code={weatherConditionCode}
          />{" "}
          Good Afternoon
        </>
      );
    } else if (hours >= 18 && hours < 22) {
      greeting = (
        <>
          <WeatherIcon isDay={isDay} code={weatherConditionCode} /> Good Evening
        </>
      );
    } else {
      return (
        <>
          <WeatherIcon isDay={isDay} code={weatherConditionCode} /> Good Evening
        </>
      );
    }

    return greeting;
  };

  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const suggBoxRef = useRef(null);

  const handleClickOutsideSugg = (event) => {
    if (suggBoxRef.current && !suggBoxRef.current.contains(event.target)) {
      setShowSuggestions(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideSugg);

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideSugg);
    };
  }, []);

  const getSuggestions = useDebouncedCallback(() => {
    autoSuggest(message)
      .then((res) => {
        if (processing) return;
        if (!processing) setShowSuggestions(true);
        setSuggestions(res.suggestions);
      })
      .catch((e) => {
        setShowSuggestions(false);
      });
  }, 500);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      style={{
        textDecoration: "none",
      }}
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </a>
  ));

  // Avatars section

  const { setAvatarB64, getAvatarB64 } = useAvatar();
  const [avatarB64Local, setAvatarB64Local] = useState(null);
  const [changingAvatar, setChangingAvatar] = useState(false);

  const handleFileChange = async (event) => {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }
    const file = event.target.files[0];

    // Validate file type (JPEG/PNG)
    if (!["image/jpeg", "image/png"].includes(file.type)) {
      alert("Only JPEG and PNG formats are allowed.");
      return;
    }

    try {
      setChangingAvatar(true);
      await changeAvatar(file);

      // Fetch and update the base64 image in the hook state
      const avatar = await getAvatarB64(true);
      setAvatarB64Local(avatar);
      setChangingAvatar(false);
      alert("Avatar updated successfully!");
    } catch (error) {
      alert(error.message);
      setChangingAvatar(false);
    }
  };
  useEffect(() => {
    setChangingAvatar(true);

    getAvatarB64()
      .then((avatar) => {
        setChangingAvatar(false);
        setAvatarB64Local(avatar);
      })
      .catch((e) => {
        setChangingAvatar(false);
      });
  }, []);

  const uploadAvatarRef = useRef(null);

  return (
    <>
      <Navbar bg="dark" variant="dark" expand="sm" className="w-100 m-0 nav_">
        <Container fluid className="">
          <input
            hidden
            ref={uploadAvatarRef}
            type="file"
            accept="image/jpeg,image/png"
            onChange={handleFileChange}
          />
          <Button
            disabled
            variant="outline-light"
            onClick={handleShow}
            className="border-0"
          >
            <FontAwesomeIcon icon={faBars} />
          </Button>
          <Navbar.Brand
            className=""
            style={{ cursor: "pointer" }}
            title="+ Start new chat"
            onClick={(e) => history.push("/chat/")}
          >
            <Image src={Logo} style={{ maxWidth: "100px" }} />
          </Navbar.Brand>
          <Nav className="" style={{ width: "80%" }}>
            <Nav.Link
              className={
                window.location.href.indexOf("chat") > -1
                  ? "active nav-actv nav-link-style-cust nav-link_"
                  : "nav-link_"
              }
            >
              <Link to="/chat">Chat</Link>
            </Nav.Link>
            <Nav.Link
              className={
                window.location.href.indexOf("ai-image") > -1
                  ? "active nav-actv nav-link-style-cust nav-link_"
                  : "nav-link_"
              }
            >
              <Link to="/ai-images/">
                <FontAwesomeIcon icon={faMagicWandSparkles} /> AI Images
              </Link>
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/ai-workflows/"
              className={
                window.location.href.indexOf("ai-workflows") > -1
                  ? "active nav-actv nav-link-style-cust nav-link_"
                  : "nav-link_"
              }
            >
              <FontAwesomeIcon icon={faCompassDrafting} /> Workflows
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/beats"
              title="Coming Soon!"
              className={
                window.location.href.indexOf("beats") > -1
                  ? "active nav-actv nav-link-style-cust nav-link_"
                  : "nav-link_"
              }
            >
              <FontAwesomeIcon icon={faMusic} /> Beats
            </Nav.Link>
          </Nav>
          <Dropdown align="end" className="user-avatar-dropdown">
            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
              <div className="user-avatar">
                {!avatarB64Local &&
                  !changingAvatar &&
                  (firstname ? (
                    firstname[0]
                  ) : (
                    <FontAwesomeIcon icon={faPerson} />
                  ))}
                {!changingAvatar && avatarB64Local && (
                  <Avatar
                    base64Image={avatarB64Local}
                    width="30px"
                    height="30px"
                  />
                )}
                {changingAvatar && <Spinner size="sm" />}
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Container fluid>
                <Container className="text-center">
                  <div
                    className="user-avatar"
                    style={{ margin: "0 auto", width: "80px", height: "80px" }}
                    onClick={() => {
                      if (uploadAvatarRef.current) {
                        uploadAvatarRef.current.click();
                      }
                    }}
                  >
                    {!avatarB64Local &&
                      !changingAvatar &&
                      (firstname ? (
                        firstname[0]
                      ) : (
                        <FontAwesomeIcon icon={faPerson} />
                      ))}
                    {!changingAvatar && avatarB64Local && (
                      <Avatar
                        base64Image={avatarB64Local}
                        width="70"
                        height="70px"
                      />
                    )}
                    {changingAvatar && <Spinner size="sm" />}
                  </div>
                  <br />
                  <p
                    style={{
                      fontSize: "0.7em",
                      color: "grey",
                      margin: "0 auto",
                    }}
                  >
                    {firstname} {lastname}
                  </p>
                </Container>
              </Container>
              <Dropdown.Divider />
              <Dropdown.Item
                className="user-avt-dd-itm"
                onClick={() => {
                  if (uploadAvatarRef.current) {
                    uploadAvatarRef.current.click();
                  }
                }}
              >
                <FontAwesomeIcon icon={faUserEdit} className="me-2" /> Change
                Avatar
              </Dropdown.Item>
              <Dropdown.Item
                className="user-avt-dd-itm"
              >
                <Link
                  to="/membership"
                  style={{
                    textDecoration: "none",
                    color: "white",
                  }}
                >
                  <FontAwesomeIcon icon={faIdBadge} className="me-2" />{" "}
                  Membership
                </Link>
              </Dropdown.Item>
              <Dropdown.Item
                className="user-avt-dd-itm"
              >
                <Link to="/account-settings" style={{
                  textDecoration: "none",
                  color: "white",
                  
                }}>
                  <FontAwesomeIcon icon={faShieldAlt} className="me-2" /> Account Settings
                </Link>
              </Dropdown.Item>
              <Dropdown.Item className="user-avt-dd-itm" onClick={handleLogout}>
                <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          {verified === "false" ? (
            <i className="ms-auto">
              <Badge>Unverified</Badge>
            </i>
          ) : null}
        </Container>
      </Navbar>
      <Container>
        {resendingMail && (
          <>
            <Spinner size="sm" /> Resending mail
          </>
        )}
        {!resendingMail && verified === "false" && (
          <span
            style={{ cursor: "pointer" }}
            onClick={() => {
              setResendingMail(true);
              resendVerification()
                .then(() => {
                  setResendingMail(false);
                  alert("Link sent!");
                })
                .catch((e) => {
                  setResendingMail(false);
                  alert("Couldn't send, please try again later!");
                });
            }}
          >
            <FontAwesomeIcon icon={faEnvelope} />{" "}
            <u>Resend Verification Link</u>
          </span>
        )}
        <br />
        <Container className="chat-container d-flex flex-column align-items-center">
          <Row className="w-200 py5 ppng greet-row">
            <p style={{ fontSize: "0.8em" }} className="ppngr greet-main">
              {userLocation.length > 0 && (
                <FontAwesomeIcon size="xs" icon={faLocationPin} />
              )}{" "}
              {userLocation} {userLocation ? " " : null}
              {"  "}
              <span style={{ marginLeft: "4px" }}>{getGreet()}</span>
            </p>
          </Row>
          {
            <Container>
              <Row className="chat-header w-200 text-right py-3 ppn">
                <h5 className="ppngr">
                  <b>
                    <span
                      style={{ color: "rgb(139, 57, 151)", fontSize: "1.2em" }}
                      className="lex-color"
                    >
                      Lex
                    </span>{" "}
                    <span style={{ opacity: "0.9" }}>Images</span>
                  </b>
                </h5>
              </Row>
            </Container>
          }
          <Row
            ref={scrollContainerRef}
            className={`text-center align-items-center message-row ${
              inputPosition === "bottom" ? "flex-grow-1" : ""
            }`}
          >
            <div
              className="ai-message-container text-center"
              style={{ width: "100%" }}
            >
              {!processing && messages.length === 0 && (
                <div className="text-white opacity-70">
                  <FontAwesomeIcon icon={faInfoCircle} />
                  No images to show, generated images will appear here.
                </div>
              )}

              {processing && (
                <>
                  <Spinner size="sm" /> Generating image...
                </>
              )}

              {messages.map((m, i) => (
                <Container key={i} className="mb-4 p-3 gen-img-cont">
                  <Row className="mb-2 justify-content-center text-align-left">
                    <Col xs={12} md={12} lg={12} className="ai-title-container">
                      <p className="ai-img-title">{m.prompt_txt}</p>
                      <p className="ai-img-date">
                        {new Date(m.created_at).toLocaleString()}{" "}
                        <Button
                          className="send-button download-ai-image-btn border-0"
                          size="sm"
                          onClick={() => {
                            const link = document.createElement("a");
                            link.setAttribute("target", "_blank");
                            link.href = m.signed_url;

                            // Set the download attribute to suggest a filename
                            link.download = "Lex-image.png"; // Change as needed

                            // Append the anchor to the document, trigger the click, and remove it
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          }}
                        >
                          Download
                        </Button>{" "}
                        <Button
                          className="send-button download-ai-image-btn border-0"
                          size="sm"
                          disabled={deleteing}
                          onClick={() => {
                            setDeleting(true);
                            deleteImage(m.file_ref)
                              .then(() => {
                                setDeleting(false);
                                setMessages((prev) =>
                                  prev.filter((p) => p.file_ref !== m.file_ref)
                                );
                              })
                              .catch((e) => {
                                setDeleting(false);
                                alert("Failure deleting image!");
                              });
                          }}
                        >
                          {deleteing ? <Spinner size={"sm"} /> : "Delete"}
                        </Button>
                      </p>
                    </Col>
                    <Col xs={12} md={12} lg={12}>
                      <Image
                        src={m.signed_url}
                        fluid
                        rounded
                        className="shadow-lg"
                        style={{
                          maxWidth: "450px",
                          marginLeft: "6px",
                        }}
                      />
                    </Col>
                  </Row>
                </Container>
              ))}
            </div>
          </Row>
          <Form className={`message-form ${inputPosition}`}>
            {!processing && suggestions.length > 0 && showSuggestions && (
              <div ref={suggBoxRef} className="suggestions-popup">
                {suggestions.map((suggestion, index) => (
                  <span
                    key={index}
                    className="suggestion-item"
                    onClick={() => setMessage(suggestion)}
                  >
                    {suggestion}
                  </span>
                ))}
              </div>
            )}
            <Form.Group className="d-flex align-items-center w-300">
              <Form.Control
                as="textarea"
                rows={1}
                autoFocus={true}
                placeholder="Enter image request.."
                value={message}
                onChange={(e) => {
                  setMessage(e.target.value);
                  if (!processing) getSuggestions();
                }}
                onKeyDown={handleKeyPress}
                className="msg-inp ms-2 border-0 text-light"
              />
              <Button
                variant="primary"
                className="send-button ms-3 border-0"
                onClick={() => {
                  if (message.trim()) {
                    initChat();
                    setShowSuggestions(false);
                  }
                }}
                disabled={processing}
              >
                {processing ? (
                  <Spinner size="sm" />
                ) : (
                  <img src="https://www.beatai.io/favicon.png" width="20"></img>
                )}
              </Button>
            </Form.Group>
          </Form>
        </Container>
      </Container>
    </>
  );
}

export default AIImage;
